export default __webpack_public_path__ + "static/RunRight5-c0d39d696ec26d98e6b11dff067eb7bd.mp3";